"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var dateCompare_1 = __importDefault(require("./dateCompare"));
var filterTimeControl = function (item) {
    if ((item === null || item === void 0 ? void 0 : item.field_valid_from) && (item === null || item === void 0 ? void 0 : item.field_valid_to)) {
        return dateCompare_1.default(item.field_valid_from, item === null || item === void 0 ? void 0 : item.field_valid_to);
    }
    if ((item === null || item === void 0 ? void 0 : item.field_valid_from) && !(item === null || item === void 0 ? void 0 : item.field_valid_to)) {
        return dateCompare_1.default(item.field_valid_from);
    }
    if (!(item === null || item === void 0 ? void 0 : item.field_valid_from) && (item === null || item === void 0 ? void 0 : item.field_valid_to)) {
        return dateCompare_1.default(undefined, item.field_valid_to);
    }
    return true;
};
exports.default = filterTimeControl;
//# sourceMappingURL=filterTimeControl.js.map